module.exports = __webpack_public_path__ + "img/t.b221edd8.jpg";